const ERROR_MESSAGES = Object.freeze({
  UNABLE_TO_GENERATE_SIGNED_URL: 'Unable to generate signed url',
  UNAVAILABLE_PRESIGNED_URL: 'The presigned url is missing',
});

export { ERROR_MESSAGES };
